module.exports = __webpack_public_path__ + "img/gw28804.9700dc20.png";